// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1944":"0f319804","3689":"a43710fa","7658":"8aa7eecc","9209":"0f319804","9824":"cbb1c580"}[chunkId] + ".chunk.css";
};